import type { YYYYMMDD } from '../typings'

import { useState } from 'react'

import { parseDate } from '../utils/parseDate'

export const useReferenceDate = (today: YYYYMMDD, initialVisibleDate?: YYYYMMDD) =>
  useState<Date>(parseDate(initialVisibleDate || today))
